// extracted by mini-css-extract-plugin
export default {"personalAdContainer":"Styles_personalAdContainer__pkrKc","linkContainer":"Styles_linkContainer__lFLEJ","bigTitle":"Styles_bigTitle__E7OdT"};